import GjwTable from './src/GjwTable'

GjwTable.install = function(Vue) {
  Vue.component(GjwTable.name, GjwTable)
}

export default GjwTable
